import { EsriBoundedBy, EsriGeneratedRow } from '../api/ach/esri';

// Builds the platform location-upload CSV from /esri/generate rows, matching the
// ESRI POC's ResultsPanel.tsx byte for byte: the 22 columns Ventura's
// CsvLocationUploader reads, in its order, with the unused ones left empty.

export const LOCATION_FILE_HEADERS = [
  'name',
  'address',
  'latitude',
  'longitude',
  'radius',
  'zipcode',
  'street',
  'location_type',
  'state',
  'city',
  'dma',
  'congressional_district',
  'lv1',
  'lv2',
  'lv3',
  'lv4',
  'lv5',
  'lv6',
  'targeting_by',
  'bounded_by',
  'excluded',
  'preceptivity_disabled',
];

const escapeCsv = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) return '';
  const str = String(value);
  return /[",\n\r]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
};

export const toLocationCsv = (rows: EsriGeneratedRow[], boundedBy: EsriBoundedBy): string => {
  const lines = [LOCATION_FILE_HEADERS.join(',')];
  rows.forEach((row) => {
    const values = [
      row.name,
      '', // address
      row.latitude,
      row.longitude,
      row.radius,
      row.zip,
      row.street,
      row.location_type,
      row.state,
      row.city,
      row.dma,
      '', // congressional_district
      '', '', '', '', '', '', // lv1-lv6
      '', // targeting_by
      boundedBy,
      '', // excluded
      '', // preceptivity_disabled
    ];
    lines.push(values.map(escapeCsv).join(','));
  });
  return lines.join('\n');
};

export const toLocationCsvFile = (rows: EsriGeneratedRow[], boundedBy: EsriBoundedBy, date = new Date()): File =>
  new File([toLocationCsv(rows, boundedBy)], `esri_location_file_${date.toISOString().slice(0, 10)}.csv`, {
    type: 'text/csv',
  });
